<div class="tags-tooltip-component">
  <div class="tag" *ngFor="let tag of tags">
    <mat-icon fontSet = "mdi" fontIcon = "mdi-tag"
              [style.color]="tag.color || '#607d8b'"></mat-icon>
    <span class="no-select">{{ tag.name }}</span>
  </div>
</div>
